import * as React from 'react';

interface Props {
  children?: React.ReactNode;
  labels: string[];
  percent: number;
  style: React.CSSProperties;
}

const ProgressBar = ({
  percent, labels, style, children
}: Props) => (
  <div
    className="cc__progress_bar"
  >
    <div className="cc__row-space_between cc__lighttext">
      <div className="cc__progress_bar__label" style={{fontWeight: 'bold', color: 'black'}}>{labels[0]}</div>
      <div className="cc__progress_bar__label">{labels[1]}</div>
    </div>
    <div className="cc__grey_bg" style={{ flex: '1', justifyContent: 'flex-start', flexDirection: 'row' }}>

      <div
        style={{ ...style, width: `${Math.round(percent * 100)}%` }}
      >&nbsp;</div>

    </div>
    <div style={{textAlign: 'center' }}>
        {children}
        </div>

  </div>
);
export default ProgressBar;
